import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  previewWrapper: {
    border: 'solid 1px #D5DDE0',
    width: '100%',
    margin: 'auto',
    maxWidth: 300,
    cursor: 'pointer',
  },
  titleIcon: {
    color: '#747C99',
    height: 48,
    verticalAlign: 'middle',
    width: 'unset',
  },
  mediaContainer: {
    borderBottom: 'solid 1px #D5DDE0',
    textAlign: 'center',
    background: '#F1F2F5',
    maxHeight: 200,
    minHeight: 100,
    maxWidth: '100%',
    height: '100%',
  },
  previewTitle: {
    color: '#515B6A',
    fontSize: 12,
    fontFamily: 'Roboto',
    marginTop: 0,
  },
  image: {
    maxWidth: '100%',
  },
  audioIcon: {
    color: '#8324B2',
    height: 24,
    verticalAlign: 'middle',
    marginRight: 10,
    width: 'unset',
  },
  title: {
    padding: '0 10px',
  },
  previewContainer: {
    height: 'fit-content',
    border: 'dashed #DCDEE5 2px',
    minHeight: 186,
  },
}), { name: 'AudioInstruction' });

export default useStyles;
